export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    values: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemCount: {
      type: String,
      default: 'count',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
  },
  methods: {
    toggleInArray(array, element, checked) {
      return checked ? [...array, element] : array.filter(it => it !== element);
    },
  },
};